/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/common/ConfirmationDialog" />
import * as React from "react";
import { IVssComponentContext, IVssLayoutManager, VssComponent } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";
import { IConfirmationDialogProps } from "Wit/Settings/BoardsExternalIntegration/components/common/ConfirmationDialog.Props";
import * as Resources from "Wit/Settings/BoardsExternalIntegration/Resources";

export class ConfirmationDialog extends VssComponent<IConfirmationDialogProps> {
    private static primaryButtonClass = "ok-button";

    constructor(props: never, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return (
            <Dialog
                showCloseButton={true}
                titleProps={{ text: this.props.title }}
                calloutClassName="external-connection-confirmation-dialog"
                lightDismiss={false}
                onDismiss={this._onDismiss}
                defaultActiveElement={".external-connection-cancel-button"}
                footerButtonProps={[
                    {
                        onClick: this._onDismiss,
                        text: Resources.ConfirmationCancel,
                        className: "external-connection-cancel-button"
                    },
                    {
                        primary: true,
                        className: ConfirmationDialog.primaryButtonClass,
                        onClick: this._onPrimaryButtonClick,
                        text: this.props.primaryButtonText
                    }
                ]}
            >
                {this.props.message}
            </Dialog>
        );
    }

    private _onPrimaryButtonClick = () => {
        this.props.onConfirmed && this.props.onConfirmed();
    };

    private _onDismiss = () => {
        this.props.onCancel && this.props.onCancel();
    };
}

export function showConfirmationDialog(
    context: IVssComponentContext,
    message: string,
    actionText: string,
    dialogTitle: string,
    onConfirmed: () => void,
    onCancel?: () => void
) {
    const layoutManager = context.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
    layoutManager.renderCallout(onDismiss => {
        return (
            <ConfirmationDialog
                title={dialogTitle}
                message={message}
                primaryButtonText={actionText}
                onConfirmed={() => {
                    onConfirmed();
                    onDismiss();
                }}
                onCancel={() => {
                    onCancel && onCancel();
                    onDismiss();
                }}
            />
        );
    });
}
